<template>
  <div
    class="d-flex justify-content-between flex-grow-1"
    style="overflow: auto"
    v-bind:class="{
      'selected text-primary': selected
    }"
  >
    <div class="quote-name">
      {{ name }}
    </div>
    <div class="quote-right">
      <span class="quote-value">{{ live.last }}{{ $currency(market) }}</span>
      <el-tooltip
        :content="$moment(this.live.lt * 1000).format('llll')"
        effect="light"
        :open-delay="300"
        placement="top"
      >
        <span
          :title="JSON.stringify(live)"
          class="quote-percent"
          v-bind:class="{ negative: percent < 0 }"
        >
          {{ percent }}%
        </span>
      </el-tooltip>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    name: {
      type: String,
      default: "TEST"
    },
    market: {
      type: String,
      default: "XPAR"
    },
    live: {
      type: Object,
      default: () => {
        return {};
      }
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    percent: function() {
      let lc = this.live.c || this.live.o;
      let last = this.live.last || this.live.c;
      if (!lc) return "NA";
      return parseFloat(((last - lc) / lc) * 100).toFixed(2);
    }
  }
};
</script>
<style></style>
